import { KTSVG } from '_metronic/helpers'
import { findFileIconAbsoluteUrl } from 'Utils/findFileIconAbsoluteUrl'
import { calculateFileSize } from 'Utils/calculateFileSize'

const FileCard: React.FC<{ file: File; removeFile: () => void }> = ({ file, removeFile }) => {
  return (
    <div className='card border'>
      <div className='card-body'>
        <div className='row align-items-center justify-content-center'>
          <div className='col-2 col-xl-1'>
            <div
              className='w-40px h-40px bg-light-primary d-flex align-items-center justify-content-center'
              style={{ borderRadius: '50%' }}>
              <KTSVG
                path={findFileIconAbsoluteUrl(file)}
                className='svg-icon svg-icon-1 svg-icon-primary z-1'
              />
            </div>
          </div>

          <div className='col-10 col-xl-7 d-flex flex-column'>
            <div className='fw-bold text-grey-700'>{file?.name}</div>
            <div className='text-grey-600'>{calculateFileSize(file?.size ?? 0)}</div>
          </div>

          <div className='col-12 col-xl-4 text-end'>
            <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={removeFile}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen027.svg' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FileCard
